module.exports = __webpack_public_path__ + "img/edit_task.caf4fa9b.svg";